import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { getApi } from '../../services/apiServices';
import { toast } from 'react-toastify';

function PlanHistory() {
  const [activeTab, setActiveTab] = useState('all');
  const [planHistory, setPlanHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const limit = 10;

  const fetchPlanHistory = async () => {
    setLoading(true);
    setError(null);
    try {
      const params = new URLSearchParams();
      params.append('page', currentPage);
      params.append('limit', limit);

      const response = await getApi(`plan-history?${params.toString()}`);

      if (response?.statusCode === 200) {
        setPlanHistory(response.data?.users || []);
        const paginationData = response.data?.pagination;
        if (paginationData) {
          setTotalPages(paginationData.total_pages || 1);
          setTotalRecords(paginationData.total || 0);
        }
      } else {
        setError(response?.message || 'Failed to fetch plan history');
        console.error('Failed to fetch plan history:', response?.message);
      }
    } catch (error) {
      setError('Error fetching plan history. Please try again.');
      console.error('Error fetching plan history:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPlanHistory();
  }, [currentPage]);

  const formatDate = (timestamp) => {
    if (!timestamp || timestamp === "-9223372036854775808") return "N/A";
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  };

  // Get status text based on status code
  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return "Active";
      case 2:
        return "Past Due";
      case 3:
        return "Payment Failed";
      case 4:
        return "Canceled";
      case 5:
        return "Incomplete";
      case 6:
        return "Incomplete Expired";
      default:
        return "Unknown";
    }
  };



  // Generate upgrade history string from plan_history array
  const generateUpgradeHistory = (planHistory) => {
    if (!planHistory || planHistory.length === 0) return "—";
    
    // Sort by start_date to get chronological order
    const sortedHistory = [...planHistory].sort((a, b) => a.start_date - b.start_date);
    
    // Extract package names
    const packages = sortedHistory.map(plan => plan.package);
    
    // Remove duplicates and join with arrows
    const uniquePackages = [...new Set(packages)];
    return uniquePackages.join(" → ");
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const getFilteredData = () => {
    if (activeTab === 'all') {
      return planHistory;
    } else if (activeTab === 'active') {
      return planHistory.filter(item => item.latest_plan?.status === 1);
    } else if (activeTab === 'expired') {
      return planHistory.filter(item => item.latest_plan?.status === 2 || item.latest_plan?.status === 4);
    }
    return planHistory;
  };

  const filteredData = getFilteredData();

  return (
    <>
      <div className="right-section">
        <div className="customer-top">
          <div className="customer-top-left">
            {/* <ul>
              <li>
                <a 
                  href="#" 
                  className={activeTab === 'all' ? 'active' : ''} 
                  onClick={(e) => { 
                    e.preventDefault(); 
                    handleTabChange('all'); 
                  }}
                >
                  All
                </a>
              </li>
              <li>
                <a 
                  href="#" 
                  className={activeTab === 'active' ? 'active' : ''} 
                  onClick={(e) => { 
                    e.preventDefault(); 
                    handleTabChange('active'); 
                  }}
                >
                  Active
                </a>
              </li>
              <li>
                <a 
                  href="#" 
                  className={activeTab === 'expired' ? 'active' : ''} 
                  onClick={(e) => { 
                    e.preventDefault(); 
                    handleTabChange('expired'); 
                  }}
                >
                  Expired
                </a>
              </li>
            </ul> */}
          </div>
        </div>

        {loading && (
          <div className="loader-overlay">
            <span className="loader"></span>
          </div>
        )}

        <div className="customer-tablle-main plan-history-data">
          <table className="table">
            <thead>
              <tr>
                <th className="name" scope="col">Name</th>
                <th className="plan" scope="col">Current Plan</th>
                <th className="date" scope="col">Start Date</th>
                <th className="status" scope="col">Status</th>
                <th className="upgrade" scope="col">Upgrade History</th>
                <th className="action" scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="text-center py-4">
                    <div className="text-muted">Loading plan history...</div>
                  </td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="6" className="text-center py-4 text-danger">{error}</td>
                </tr>
              ) : filteredData.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center py-4">No plan history found.</td>
                </tr>
              ) : (
                filteredData.map((user) => (
                  <tr key={user.user_id}>
                    <td className="name">
                      <div className="table-mails">
                        <span className="profile-img">
                          <img
                            src={window.getPublicUrl('/images/john.svg')}
                            alt={user.name}
                          />
                        </span>
                        <div>
                          <h3>{user.name}</h3>
                        </div>
                      </div>
                    </td>
                    <td className="plan">{user.latest_plan?.package || "N/A"}</td>
                    <td className="date">{formatDate(user.latest_plan?.start_date)}</td>
                    <td className="status">
                      <button className={`btn btn-status ${user.latest_plan?.status === 1 ? 'btn-status-primary' : 'btn-status-block'}`}>
                        <img 
                          src={window.getPublicUrl(user.latest_plan?.status === 1 ? '/images/dot.svg' : '/images/block-dots.svg')} 
                          alt={getStatusText(user.latest_plan?.status)} 
                        />
                        {getStatusText(user.latest_plan?.status)}
                      </button>
                    </td>
                    <td className="upgrade">{generateUpgradeHistory(user.plan_history)}</td>
                    <td className="action">
                      <div className="view-image">
                        <Link to={`/admin/planHistoryDetail/${user.user_id}`}>
                          <button className="btn">
                            <img src={window.getPublicUrl('/images/view.svg')} alt="View" />
                          </button>
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {totalPages > 1 && (
          <div className="pagination-wrapper" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px' }}>
            <div className="pagination-info" style={{ fontSize: '14px', color: '#888', fontWeight: '400' }}>
              Showing {(currentPage - 1) * limit + 1} to {Math.min(currentPage * limit, totalRecords)} of {totalRecords} records
            </div>
            <div className="pagination-controls" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <button
                className="btn"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                style={{ width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', border: '1px solid #e0e0e0', borderRadius: '8px', background: currentPage === 1 ? '#f5f5f5' : '#fff', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', color: currentPage === 1 ? '#ccc' : '#E94057', padding: 0 }}
              >
                &lsaquo;
              </button>
              {(() => {
                const pages = [];
                let startPage = Math.max(1, currentPage - 2);
                let endPage = Math.min(totalPages, startPage + 4);
                if (endPage - startPage < 4) {
                  startPage = Math.max(1, endPage - 4);
                }
                if (startPage > 1) {
                  pages.push(
                    <button key={1} className="btn" onClick={() => setCurrentPage(1)}
                      style={{ width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', border: '1px solid #e0e0e0', borderRadius: '8px', background: '#fff', color: '#333', cursor: 'pointer', padding: 0, fontWeight: '500' }}>1</button>
                  );
                  if (startPage > 2) {
                    pages.push(<span key="start-dots" style={{ padding: '0 4px', color: '#999', fontSize: '14px' }}>...</span>);
                  }
                }
                for (let i = startPage; i <= endPage; i++) {
                  pages.push(
                    <button
                      key={i}
                      className="btn"
                      onClick={() => setCurrentPage(i)}
                      style={{
                        width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: '14px',
                        border: i === currentPage ? '1px solid #E94057' : '1px solid #e0e0e0',
                        borderRadius: '8px',
                        background: i === currentPage ? '#E94057' : '#fff',
                        color: i === currentPage ? '#fff' : '#333',
                        cursor: 'pointer',
                        fontWeight: '500',
                        padding: 0
                      }}
                    >
                      {i}
                    </button>
                  );
                }
                if (endPage < totalPages) {
                  if (endPage < totalPages - 1) {
                    pages.push(<span key="end-dots" style={{ padding: '0 4px', color: '#999', fontSize: '14px' }}>...</span>);
                  }
                  pages.push(
                    <button key={totalPages} className="btn" onClick={() => setCurrentPage(totalPages)}
                      style={{ width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', border: '1px solid #e0e0e0', borderRadius: '8px', background: '#fff', color: '#333', cursor: 'pointer', padding: 0, fontWeight: '500' }}>{totalPages}</button>
                  );
                }
                return pages;
              })()}
              <button
                className="btn"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                style={{ width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', border: '1px solid #e0e0e0', borderRadius: '8px', background: currentPage === totalPages ? '#f5f5f5' : '#fff', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', color: currentPage === totalPages ? '#ccc' : '#E94057', padding: 0 }}
              >
                &rsaquo;
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default PlanHistory;